<template>
  <div
      v-if="!refresh"
      :id="schema.ref"
      class="sk-icon-wrapper sk-app-edit-container flex"
      :style="parentStyle"
  >
    <div :style="style" class="flex flex-column">
      <div class="flex flex1 wp100" :style="contentStyle">
        <div
            :class="comCls"
            class="index-card-item flex1 flex-column between opt-box"
            :style="getItemStyle(item, index)"
            v-for="(item, index) in data"
            :key="index"
        >
          <div
              :style="getoptStyle(item, index)"
              class="opt-style"
              v-if="prop.cardType == CARD_TYPE.OPT"
          ></div>
          <!--          主辅竖向 横向-->
          <div
              :title="getTip(item.value + (item?.set?.indexUnit || '') || '--')"
              :style="
              prop.mainAssistType === 'row'
                ? {
                    display: 'flex',
                    'align-items': 'flex-end',
                    gap: `${prop.intervalGap}px`,
                  }
                : {}
            "
          >
            <div
                :class="prop.mainAssistType !== 'row' && 'top-name'"
                :style="titleStyle"
            >
              <div class="flex vcenter">
                <div>
                  <el-tooltip
                      :disabled="
                      calcEllipsis(
                        item?.set?.indexAlias || item.name,
                        'name'
                      ) === (item?.set?.indexAlias || item.name)
                    "
                      effect="dark"
                      :content="item?.set?.indexAlias || item.name"
                  >
                    <span
                        @click="(e) => handleNameClick(e, item)"
                        :style="{
                        cursor: props.isPieCard ? 'default' : 'pointer',
                      }"
                    >
                      {{
                        calcEllipsis(item?.set?.indexAlias || item.name, "name")
                      }}
                    </span>
                  </el-tooltip>
                  <el-tooltip
                      effect="dark"
                      v-if="item?.set?.indexTip"
                      :content="item?.set?.indexTip"
                      placement="top"
                  >
                    <el-icon>
                      <QuestionFilled/>
                    </el-icon>
                  </el-tooltip>
                </div>
                <div
                    v-if="prop.showOrigin"
                    class="ml-20 index-source-item-container"
                    :style="originStyle"
                >
                  <span title="">
                    <svg
                        class="index-source-item index-source-left"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                    >
                      <rect width="24" height="24" rx="2" fill="#ECECEC"/>
                      <path
                          d="M18.0886 9.90283H18.1384C19.0602 9.90283 19.8074 10.6511 19.8074 11.5741V16.5377C19.8074 18.8794 17.9114 20.7779 15.5727 20.7779H12.1182C11.4506 20.7777 10.7926 20.6197 10.1977 20.3167C9.6029 20.0138 9.08816 19.5744 8.69554 19.0345L5.31528 14.3889C5.0943 14.0852 4.98374 13.715 5.00193 13.3398C5.02012 12.9646 5.16597 12.6068 5.4153 12.3258L5.57242 12.1488C6.16002 11.487 7.17215 11.4274 7.83308 12.0157C7.84904 12.0299 7.86464 12.0443 7.87998 12.0591L8.52468 12.6807C8.54823 12.7034 8.57602 12.7213 8.60648 12.7333C8.63694 12.7452 8.66946 12.7511 8.70218 12.7505C8.7349 12.7499 8.76718 12.7428 8.79717 12.7297C8.82716 12.7166 8.85427 12.6977 8.87696 12.6741C8.92166 12.6276 8.9466 12.5656 8.94656 12.501V6.78503C8.94656 5.862 9.69385 5.11391 10.6155 5.11391H10.6654C11.5872 5.11391 12.3344 5.86209 12.3344 6.78503V8.29627C12.5727 8.17154 12.8377 8.10657 13.1066 8.10697H13.1564C13.9223 8.10697 14.5677 8.62354 14.7641 9.32774C15.0174 9.1812 15.3049 9.10423 15.5976 9.10465H15.6474C16.3519 9.10465 16.9544 9.5416 17.1993 10.1596C17.4654 9.9914 17.7738 9.90235 18.0886 9.90283ZM9.33226 18.57C9.65184 19.0094 10.0708 19.3671 10.555 19.6137C11.0392 19.8603 11.5748 19.9889 12.1182 19.989H15.5727C17.4763 19.989 19.0196 18.4437 19.0196 16.5375V11.5739C19.0196 11.0867 18.625 10.6917 18.1384 10.6917H18.0886C17.602 10.6917 17.2075 11.0867 17.2075 11.5739V13.3449C17.2075 13.798 16.5286 13.798 16.5286 13.3449V10.7758C16.5286 10.2885 16.134 9.89352 15.6474 9.89352H15.5976C15.111 9.89352 14.7165 10.2885 14.7165 10.7758V12.7463C14.7165 13.1994 14.0376 13.1994 14.0376 12.7463V9.77816C14.0376 9.29085 13.643 8.89584 13.1564 8.89584H13.1066C12.62 8.89584 12.2255 9.29085 12.2255 9.77808V12.1477C12.2255 12.6008 11.5465 12.6008 11.5465 12.1477V6.78512C11.5465 6.2978 11.152 5.9027 10.6654 5.9027H10.6155C10.1289 5.9027 9.73446 6.2978 9.73446 6.78503V12.501C9.73446 12.7696 9.63054 13.0276 9.44452 13.2211C9.04729 13.6342 8.39071 13.6466 7.97823 13.2489L7.33353 12.6272C7.25466 12.5511 7.16123 12.4918 7.05884 12.4527C6.95645 12.4137 6.84722 12.3958 6.73772 12.4C6.62822 12.4043 6.52071 12.4306 6.42166 12.4775C6.32261 12.5244 6.23406 12.5908 6.16135 12.6728L6.00414 12.8498C5.87427 12.9961 5.7983 13.1824 5.78882 13.3779C5.77934 13.5733 5.83691 13.7661 5.952 13.9243L9.33226 18.57ZM13.9997 6.41369C13.9997 6.5195 13.9576 6.62096 13.8828 6.69577C13.808 6.77058 13.7065 6.81261 13.6007 6.81261C13.4949 6.81261 13.3934 6.77058 13.3186 6.69577C13.2438 6.62096 13.2017 6.5195 13.2017 6.41369C13.2017 4.96912 12.0306 3.798 10.586 3.798C9.14145 3.798 7.97033 4.96912 7.97033 6.41369C7.97034 6.46609 7.96003 6.51799 7.93999 6.5664C7.91994 6.61482 7.89055 6.65882 7.8535 6.69588C7.81645 6.73294 7.77246 6.76234 7.72404 6.78239C7.67563 6.80245 7.62374 6.81277 7.57133 6.81277C7.51893 6.81277 7.46704 6.80245 7.41862 6.78239C7.37021 6.76234 7.32622 6.73294 7.28916 6.69588C7.25211 6.65882 7.22272 6.61482 7.20268 6.5664C7.18263 6.51799 7.17232 6.46609 7.17233 6.41369C7.17233 4.52836 8.70069 3 10.586 3C12.4713 3 13.9997 4.52836 13.9997 6.41369Z"
                          fill="#AFAFAF"
                          stroke="#AFAFAF"
                          stroke-width=".2"
                      />
                    </svg>
                  </span>
                  <span title="">
                    <svg
                        class="index-source-item index-source-right ml-8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                    >
                      <rect width="24" height="24" rx="2" fill="#ECECEC"/>
                      <path
                          d="M9.3922 20.2153H9.3924C9.7088 20.2153 10.0164 20.0844 10.2151 19.8652C10.4859 19.5683 11.3436 18.7964 12.0458 18.7964C12.7431 18.7964 13.6141 19.5728 13.8643 19.8447C14.0625 20.0601 14.368 20.1888 14.6815 20.1888C14.8307 20.1888 14.9717 20.1601 15.1003 20.1036L15.1227 20.0937L17.257 18.9002L17.2781 18.8854C17.6667 18.6133 17.8144 18.0814 17.622 17.648C17.6205 17.6446 17.4252 17.1939 17.4252 16.7828C17.4252 15.5354 18.4399 14.5206 19.6876 14.5206H19.7631L19.777 14.5208C20.1342 14.5208 20.4252 14.2033 20.5182 13.7119C20.5255 13.673 20.7002 12.7412 20.7002 12.007C20.7002 11.2728 20.5255 10.341 20.5182 10.3016C20.4241 9.80407 20.1268 9.48447 19.7631 9.49327H19.6876C18.44 9.49327 17.4252 8.47827 17.4252 7.23077C17.4252 6.81997 17.6203 6.36907 17.6224 6.36477C17.8147 5.93157 17.6659 5.39987 17.2758 5.12867L17.2537 5.11337L15.0013 3.87607L14.9779 3.86617C14.8511 3.81207 14.7121 3.78467 14.565 3.78467C14.2522 3.78467 13.9463 3.91047 13.7462 4.12137C13.4796 4.40047 12.6369 5.12637 11.9547 5.12637C11.2794 5.12637 10.4419 4.41477 10.176 4.14057C9.9772 3.93407 9.6731 3.81037 9.3635 3.81037C9.2133 3.81037 9.0718 3.83877 8.943 3.89487L8.9202 3.90477L6.7447 5.11347L6.7232 5.12837C6.334 5.40007 6.18599 5.93197 6.37829 6.36577C6.37999 6.36897 6.5752 6.81997 6.5752 7.23087C6.5752 8.47837 5.56049 9.49337 4.31299 9.49337H4.23729C3.87419 9.48507 3.57659 9.80407 3.48239 10.3017C3.47499 10.341 3.3002 11.2728 3.3002 12.007C3.3002 12.741 3.47499 13.673 3.48239 13.7121C3.57649 14.2098 3.87419 14.5281 4.23729 14.5208H4.31299C5.56049 14.5208 6.5752 15.5356 6.5752 16.783C6.5752 17.194 6.38 17.6446 6.378 17.6492C6.186 18.0818 6.3342 18.6138 6.7238 18.8853L6.7457 18.9004L8.9578 20.1231L8.9808 20.133C9.1074 20.1877 9.2459 20.2153 9.3922 20.2153ZM9.45939 19.173C9.44929 19.1796 9.4215 19.1906 9.3922 19.1906L9.3889 19.1905L7.3219 18.0482C7.3718 17.9322 7.6001 17.3699 7.6001 16.7832C7.6001 15.0285 6.218 13.5904 4.4853 13.5006C4.4605 13.3629 4.32509 12.5883 4.32509 12.007C4.32509 11.4258 4.4605 10.6515 4.4853 10.5134C6.218 10.4235 7.6001 8.98547 7.6001 7.23077C7.6001 6.64327 7.3713 6.08017 7.3217 5.96517L9.35499 4.83547C9.35719 4.83537 9.3603 4.83517 9.3635 4.83517C9.3981 4.83517 9.43049 4.84767 9.44109 4.85497C9.47539 4.89007 9.77009 5.18887 10.1933 5.48677C10.8201 5.92777 11.4126 6.15127 11.9546 6.15127C12.5021 6.15127 13.0996 5.92327 13.7302 5.47357C14.1559 5.16997 14.4523 4.86547 14.4863 4.82977C14.4972 4.82237 14.5299 4.80947 14.5649 4.80947L14.5723 4.80967L16.6783 5.96637C16.6279 6.08377 16.4004 6.64507 16.4004 7.23077C16.4004 8.98547 17.7823 10.4235 19.5151 10.5135C19.5401 10.6513 19.6755 11.4258 19.6755 12.0071C19.6755 12.5882 19.5401 13.3624 19.5151 13.5007C17.7823 13.5905 16.4004 15.0284 16.4004 16.7831C16.4004 17.3719 16.6301 17.9361 16.6791 18.0496L14.6858 19.1642C14.6611 19.1649 14.6366 19.159 14.6149 19.1472C14.5776 19.1072 14.2798 18.7921 13.8509 18.4779C13.2118 18.0094 12.6044 17.7719 12.0457 17.7719C11.4816 17.7719 10.8695 18.0139 10.2267 18.4912C9.79539 18.8115 9.49629 19.1326 9.45939 19.173Z"
                          fill="#AFAFAF"
                      />
                      <path
                          d="M12.0381 15.0084C13.6993 15.0084 15.0508 13.6568 15.0508 11.9956C15.0508 10.3344 13.6993 8.98291 12.0381 8.98291C10.3766 8.98291 9.02518 10.3344 9.02518 11.9956C9.02518 13.6568 10.3766 15.0084 12.0381 15.0084ZM12.0381 10.0075C13.1342 10.0075 14.0261 10.8994 14.0261 11.9955C14.0261 13.0917 13.1343 13.9835 12.0381 13.9835C10.9417 13.9835 10.0498 13.0917 10.0498 11.9955C10.0498 10.8994 10.9417 10.0075 12.0381 10.0075Z"
                          fill="#AFAFAF"
                      />
                    </svg>
                  </span>
                </div>
              </div>
            </div>
            <div
                :style="
                prop.mainAssistType !== 'column'
                  ? {
                      display: 'flex',
                      'align-items': 'flex-end',
                      gap: `${prop.intervalGap}px`,
                    }
                  : {}
              "
            >
              <div class="bottom-value" :style="ValueStyle">
                <template v-if="themeCfg?.iconSet?.arrowPosition === 'left'">
                  <span
                      class="color mr-4"
                      :style="{
                      width: `${prop.unitFontSize || 12}px`,
                      height: `${prop.unitFontSize || 12}px`,
                      display: 'inline-block',
                      verticalAlign: 'bottom',
                      fontSize: `${prop.unitFontSize}px`,
                      color:
                        arrowMapData[index]?.color ||
                        (item.value > 0 ? '#E84B45' : '#39ACAA'),
                    }"
                      :class="
                      !item?.set?.metricStyleCondition
                        ? item.value > 0
                          ? 'gre'
                          : 'r1'
                        : ''
                    "
                      v-if="item?.set?.showMainMark && 'value' in item"
                  >
                    <!-- !item?.set?.metricStyleCondition 兼容老的逻辑红正绿负 -->
                    <!--                  是否在左侧展示-->
                    <template
                        v-if="
                        arrowMapData[index]?.iconType === 'up' ||
                        (!item?.set?.metricStyleCondition && item.value > 0)
                      "
                    >
                      <span
                          v-if="themeCfg?.iconSet?.upImage"
                          v-html="upSvgStr"
                      ></span>
                      <svg
                          v-else
                          style="width: 100%; height: 100%"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 17 17"
                          class="design-iconfont"
                      >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M9.25879 1.66675L14.7588 9.07782L11.1487 8.23494L11.0907 8.26075L11.0457 8.60629C10.5256 12.0791 8.36967 14.849 5.5952 15.6667C6.47777 14.3447 6.82335 13.994 7.14396 12.1147C7.3577 10.8619 7.45525 9.57586 7.4366 8.25659L7.53375 8.2555L7.4896 8.23494L3.75879 9.07782L9.25879 1.66675Z"
                            fill="currentColor"
                        />
                      </svg>
                    </template>
                    <template
                        v-if="
                        arrowMapData[index]?.iconType === 'down' ||
                        (!item?.set?.metricStyleCondition && item.value < 0)
                      "
                    >
                      <span
                          v-if="themeCfg?.iconSet?.downImage"
                          v-html="downSvgStr"
                      ></span>
                      <svg
                          v-else
                          style="width: 100%; height: 100%"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 17 17"
                          class="design-iconfont"
                      >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M9.21875 15.6667L3.71875 8.25568L7.32885 9.09855L7.38686 9.07275L7.43181 8.72721C7.95196 5.25436 10.1079 2.48454 12.8823 1.66675C11.9998 2.98879 11.6542 3.33954 11.3336 5.21877C11.1198 6.47159 11.0223 7.75764 11.0409 9.07691L10.9438 9.078L10.9879 9.09856L14.7188 8.25568L9.21875 15.6667Z"
                            fill="currentColor"
                        />
                      </svg>
                    </template>
                  </span>
                </template>
                <el-tooltip
                    :disabled="
                    calcEllipsis(util.default__(item.value), 'value') ===
                    util.default__(item.value)
                  "
                    effect="dark"
                    :content="getTip(String(item.value) || '--')"
                >
                 <span @click="toggleMode(false)">
                    <el-link
                        v-if="item?.set?.openLink"
                        :underline="false"
                        type="primary"
                        @click.stop="handleClick(item)"
                    >
                    <span :style="getVColor(item, index)">
                      {{ calcEllipsis(util.default__(item.value), "value") }}
                    </span>
                  </el-link>
                  <span v-else :style="getVColor(item, index)">
                    {{ calcEllipsis(util.default__(item.value), "value") }}
                  </span>
                 </span>
                </el-tooltip>
                <span class="v-unit" :style="getUnitStyle(item, index)"
                >{{ item?.set?.indexUnit }}
                </span>
                <span
                    class="color"
                    :style="{
                    width: `${prop.unitFontSize || 12}px`,
                    height: `${prop.unitFontSize || 12}px`,
                    display: 'inline-block',
                    verticalAlign: 'bottom',
                    fontSize: `${prop.unitFontSize}px`,
                    color:
                      arrowMapData[index]?.color ||
                      (item.value > 0 ? '#E84B45' : '#39ACAA'),
                  }"
                    :class="
                    !item?.set?.metricStyleCondition
                      ? item.value > 0
                        ? 'gre'
                        : 'r1'
                      : ''
                  "
                    v-if="item?.set?.showMainMark && 'value' in item"
                >
                  <!-- !item?.set?.metricStyleCondition 兼容老的逻辑红正绿负 -->
                  <!--                  是否在右侧展示-->
                  <template
                      v-if="
                      themeCfg?.iconSet?.arrowPosition === 'right' ||
                      !themeCfg?.iconSet?.arrowPosition
                    "
                  >
                    <template
                        v-if="
                        arrowMapData[index]?.iconType === 'up' ||
                        (!item?.set?.metricStyleCondition && item.value > 0)
                      "
                    >
                      <span
                          v-if="themeCfg?.iconSet?.upImage"
                          v-html="upSvgStr"
                      ></span>
                      <svg
                          v-else
                          style="width: 100%; height: 100%"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 17 17"
                          class="design-iconfont"
                      >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M9.25879 1.66675L14.7588 9.07782L11.1487 8.23494L11.0907 8.26075L11.0457 8.60629C10.5256 12.0791 8.36967 14.849 5.5952 15.6667C6.47777 14.3447 6.82335 13.994 7.14396 12.1147C7.3577 10.8619 7.45525 9.57586 7.4366 8.25659L7.53375 8.2555L7.4896 8.23494L3.75879 9.07782L9.25879 1.66675Z"
                            fill="currentColor"
                        />
                      </svg>
                    </template>
                    <template
                        v-if="
                        arrowMapData[index]?.iconType === 'down' ||
                        (!item?.set?.metricStyleCondition && item.value < 0)
                      "
                    >
                      <span
                          v-if="themeCfg?.iconSet?.downImage"
                          v-html="downSvgStr"
                      ></span>
                      <svg
                          v-else
                          style="width: 100%; height: 100%"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 17 17"
                          class="design-iconfont"
                      >
                        <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M9.21875 15.6667L3.71875 8.25568L7.32885 9.09855L7.38686 9.07275L7.43181 8.72721C7.95196 5.25436 10.1079 2.48454 12.8823 1.66675C11.9998 2.98879 11.6542 3.33954 11.3336 5.21877C11.1198 6.47159 11.0223 7.75764 11.0409 9.07691L10.9438 9.078L10.9879 9.09856L14.7188 8.25568L9.21875 15.6667Z"
                            fill="currentColor"
                        />
                      </svg>
                    </template>
                  </template>
                </span>
              </div>
              <template
                  v-if="
                  item?.set?.assistIndexs?.length &&
                  prop.mainAssistType !== 'column'
                "
                  :key="_index"
                  v-for="(_item, _index) in item.set.assistIndexs"
              >
                <AssistValue
                    v-model:presentMode="presentMode"
                    :upSvgStr="upSvgStr"
                    :downSvgStr="downSvgStr"
                    :themeCfg="themeCfg"
                    :item="_item"
                    :option="prop"
                    :assistMetrics="dataOption.assistMetrics"
                ></AssistValue>
              </template>
            </div>
          </div>
          <template
              v-if="
              item?.set?.assistIndexs?.length &&
              prop.mainAssistType === 'column'
            "
              :key="_index"
              v-for="(_item, _index) in item.set.assistIndexs"
          >
            <AssistValue
                v-model:presentMode="presentMode"
                :upSvgStr="upSvgStr"
                :downSvgStr="downSvgStr"
                :themeCfg="themeCfg"
                :item="_item"
                :option="prop"
                :assistMetrics="dataOption.assistMetrics"
            ></AssistValue>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inheritAttrs: false,
};
</script>
<script setup>
import ChartNav from "@/components/drillNav.vue";
import {useRender} from "@/option/components/useRender";
import {useCommonMix} from "@/option/common/commonmix";

import {Top, Bottom} from "@element-plus/icons-vue";
import upSvg from "@/assets/svgs/up.svg";
import downSvg from "@/assets/svgs/down.svg";
import {
  computed,
  nextTick,
  onMounted,
  ref,
  unref,
  useAttrs,
  watch,
  watchEffect,
} from "vue";
import util from "@/option/common/util";
import {refDebounced, useDebounceFn, useEventBus, useEventListener} from "@vueuse/core";
import {formatValue, getSetColors} from "@/option/common/common.js";
import {
  CARD_TYPE,
  CHART_TYPE,
  DATA_SOURCE_TYPE,
} from "@/option/common/dict.js";
import {cloneDeep} from "lodash-es";
import AssistValue from "components/indexCard/assistValue.vue";
import {QuestionFilled} from "@element-plus/icons-vue";
import {generateConfig} from "@/option/common/indexConfig";
import {getSVGWithColor} from "@/utils/utils";

const emit = defineEmits(["select", "handleIndexCardClick"]);
let attrs = useAttrs();
let _originAttr = {...attrs};
delete _originAttr.style;
delete _originAttr.id;
let attr = _originAttr;
// isPieCard 是否是环图指标卡
const props = defineProps([
  "schema",
  "select",
  "dataChart",
  "layoutType",
  "dataOption",
  "isPieCard",
  "echartOption",
  "getColor",
  "dCode",
  "mCode",
  "chartNavData",
]);
let prop = computed(() => props.schema.prop);
const presentMode = ref(props?.schema?.themeCfg?.presentMode && localStorage.getItem('presentMode') === 'true' && !props.dataOption.presentDisabled)
const presentModeEvent = useEventBus('presentMode')
presentModeEvent.on((v) => {
  if (!props.dataOption.presentDisabled) {
    presentMode.value = v
  }
})
const refresh = ref(false)
watch(() => presentMode.value, (v) => {
  // 演示模式变化重新渲染
  refresh.value = true
  nextTick(() => {
    refresh.value = false
  })
})

function toggleMode(v) {
  presentMode.value = v
}

const {confirm, success, warning, error} = useCommonMix();
let {
  handleSchemaSelect,
  clz,
  createNode,
  getParentStyle,
  getDelStyle,
  handleChildSchemaSelect,
} = useRender(emit, props, attrs);
let CopyData = function (obj) {
  return JSON.parse(JSON.stringify(obj));
};
let themeCfg = computed(() => props.schema.themeCfg);
let titleStyle = computed(() => {
  return {
    color:
        prop.value.titleColor || themeCfg.value?.titleSet?.titleFontSet?.color,
    fontSize:
        (prop.value.titleFontSize ||
            themeCfg.value?.titleSet?.titleFontSet?.size) + "px",
    fontWeight: prop.value.titleWeight,
    lineHeight: "100%",
  };
});
let ValueStyle = computed(() => {
  return {
    color:
        prop.value.valueColor || themeCfg.value?.chartSet?.seriesLabelSet?.color,
    fontSize:
        (prop.value.valueFontSize ||
            themeCfg.value?.chartSet?.seriesLabelSet?.size) + "px",
    fontWeight: prop.value.valueWeight,
    lineHeight: "100%",
  };
});
const upSvgStr = ref("");
const downSvgStr = ref("");

function initSvg() {
  if (themeCfg.value?.iconSet?.upImage) {
    getSVGWithColor(
        themeCfg.value?.iconSet?.upImage,
        themeCfg.value?.iconSet?.upColor
    ).then((el) => {
      upSvgStr.value = el;
    });
  }
  if (themeCfg.value?.iconSet?.downImage) {
    getSVGWithColor(
        themeCfg.value?.iconSet?.downImage,
        themeCfg.value?.iconSet?.downColor
    ).then((el) => {
      downSvgStr.value = el;
    });
  }
}

watch(() => themeCfg.value?.iconSet?.upImage, initSvg);
watch(() => themeCfg.value?.iconSet?.downImage, initSvg);
watch(() => themeCfg.value?.iconSet?.upColor, initSvg);
watch(() => themeCfg.value?.iconSet?.downColor, initSvg);
initSvg();

function getVColor(item, index) {
  return {
    color:
        prop?.value?.valueColor ||
        (item?.set?.showMainMark && "value" in item
            ? arrowMapData.value[index]?.color ||
            (item.value > 0 ? "#E84B45" : "#39ACAA")
            : ""),
  };
}

function getUnitStyle(item, index) {
  return {
    color:
        prop.value.unitColor ||
        (item?.set?.showMainMark && "value" in item
            ? arrowMapData.value[index]?.color ||
            (item.value > 0 ? "#E84B45" : "#39ACAA")
            : ""),
    fontSize: `${prop.value.unitFontSize}px`,
    fontWeight: prop.value.unitFontWeight,
  };
}

function getTip(v) {
  return presentMode.value ? '****' : v
}

const calcEllipsis = (val, type) => {
  if (type === "value" && presentMode.value) {
    return '****'
  }
  if (type === "name" && prop.value.titleEllipsis) {
    return val.length > prop.value.titleEllipsis
        ? `${val.slice(0, prop.value.titleEllipsis)}...`
        : val;
  } else if (type === "value" && prop.value.valueEllipsis) {
    return val.length > prop.value.valueEllipsis
        ? `${val.slice(0, prop.value.valueEllipsis)}...`
        : val;
  }
  return val;
};

function handleClick(item) {
  if (item.set.link) {
    if (item.set.openLinkType === "blank") {
      window.open(item.set.link);
    } else {
      location.href = item.set.link;
    }
  }
}

function handleNameClick(e, item) {
  emit("handleIndexCardClick", {...item, event: e});
}

function getItemStyle(item, index) {
  let sty = {};
  if (prop.value.cardType === CARD_TYPE.BG) {
    // 环图特殊处理
    if (props.isPieCard) {
      sty.background = props.getColor(index);
    } else {
      if (prop.value.colorType === "single") {
        sty.background = prop.value.customColor;
      } else {
        sty.background = getSetColors(prop.value.selectedColorIndex)[index];
      }
    }
  } else if (prop.value.cardType === CARD_TYPE.LINE) {
    sty = {
      "border-color": prop.value.lineColor,
      "border-width": prop.value.lineWidth + "px",
      "padding-left": "12px",
    };
    if (props.isPieCard) {
      sty["border-color"] = props.getColor(index);
    }
  } else if (prop.value.cardType === CARD_TYPE.OPT) {
    sty["padding-left"] = "20px";
  }
  if (props.isPieCard) {
    sty["align-items"] = "flex-start";
  }
  return sty;
}

function getoptStyle(item, index) {
  if (prop.value.cardType === CARD_TYPE.OPT) {
    return {
      "background-color": props.getColor(index),
    };
  }
}

let comCls = computed(() => {
  return {
    "no-border": prop.value.cardType !== CARD_TYPE.LINE,
    bg: prop.value.cardType === CARD_TYPE.BG,
  };
});
let style = computed(() => {
  return {
    ...attrs.style,
    width: attrs?.style?.width ? attrs.style.width : "100%",
    'max-height': "100%",
  };
});
let contentStyle = computed(() => {
  let style = {
    gap: (prop.value.mainGap || 20) + "px",
  };
  if (
      prop.value.layoutType == "column-reverse" ||
      (!props.isPieCard && props.layoutType == "row")
  ) {
    style.display = "flex";
    style["flex-direction"] = "row";
  } else {
    style.display = "flex";
    style["flex-direction"] = "column";
  }
  // 横向 上中下
  if (prop.value.layoutType === "row") {
    style["justifyContent"] = "center";
    style["align-items"] = "center";
    if (
        prop.value.legendPosition === "rl" ||
        prop.value.legendPosition === "ll"
    ) {
      style["align-items"] = "flex-start";
    } else if (
        prop.value.legendPosition === "rc" ||
        prop.value.legendPosition === "lc"
    ) {
      style["align-items"] = "center";
    } else if (
        prop.value.legendPosition === "rr" ||
        prop.value.legendPosition === "lr"
    ) {
      style["align-items"] = "flex-end";
    }
  } else {
    style["justifyContent"] = "center";
    style["align-items"] = "flex-start";
    if (
        prop.value.legendPosition === "tl" ||
        prop.value.legendPosition === "bl"
    ) {
      style["justifyContent"] = "flex-start";
    } else if (
        prop.value.legendPosition === "tc" ||
        prop.value.legendPosition === "bc"
    ) {
      style["justifyContent"] = "center";
    } else if (
        prop.value.legendPosition === "tr" ||
        prop.value.legendPosition === "br"
    ) {
      style["justifyContent"] = "flex-end";
    }
  }
  return style;
});

let parentStyle = computed(() => {
  let sty = {
    position: "relative",
  };
  return sty;
});

let _data = [
  {name: "工单总数", value: 0},
  {name: "已完成工单", value: 0},
  {name: "工单完结率", value: 0},
  {name: "进行中工单", value: 0},
];
// 准备数据
let data = ref(CopyData(_data));

let chart;

function handlerRes() {
  // 环形图指标卡的情形 特殊处理
  if (props.isPieCard) {
    if (!props.dataOption?.metrics?.length) {
      // 处理假数据
      data.value = cloneDeep(props.dataChart);
      return;
    }
    let _data = cloneDeep(props.echartOption.series[0].data);
    // 指标的辅助指标配置在第一个指标上 环图只能配置一个指标
    let el = cloneDeep(props.dataOption?.metrics[0]);
    _data.forEach((_el) => {
      // 去掉二次格式化
      // if (el.set) {
      //   formatValue(el.set, _el, "value");
      // }
      let assistSet = cloneDeep(el.set) || {};
      // 查找辅助指标逻辑
      if (assistSet.assistIndexs?.length) {
        // 找到当前series项在后台返回list中的数据项
        let item = props.dataChart[_el.index];
        let target = item[props.mCode]?.assistList;
        assistSet.assistIndexs.forEach((__el, _index) => {
          // 查看后台返回的数据项中的辅助指标list 并 根据配置的辅助指标顺序赋值，和后台约定了 辅助指标按照配置的顺序返回值
          __el.value = target ? target?.[_index]?.value : "";
        });
      }
      _el.set = assistSet;
      // 这里是暂时的测试数据 上线可删除
      // if (!_el.set.assistIndexs) {
      //   _el.set.assistIndexs = [{
      //     des: '测试数据',
      //     hoverTitle: '测试数据',
      //     value: 12345,
      //   }]
      // }
    });
    let order = props.schema.prop.legendOrder
    _data = _data.sort((a, b) => {
      if (order === 'ascend') {
        return a.value - b.value;
      } else if (order === 'descend') {
        return b.value - a.value;
      } else {
        return 0;
      }
    });
    data.value = _data;
    generateArrowData(data.value);
  } else {
    if (props.dataOption?.metrics?.length) {
      data.value = cloneDeep(props.dataOption?.metrics);
      data.value.forEach((el, index) => {
        let target = props.dataChart.find(
            (item) => el.name === item.name || el.code === item.name
        );
        if (target) {
          el.value = target?.value;
          let assistList = target?.assistList || [];
          if (el.set?.assistIndexs?.length) {
            el.set?.assistIndexs.forEach((_el, _index) => {
              _el.value = assistList?.[_index]?.value;
            });
          }
        }
      });
      generateArrowData(data.value);
    }
  }
}

const arrowMapData = ref([]);

const generateArrowData = async (data) => {
  let list = [];
  for (let i = 0; i < data.length; i++) {
    let res = await calcArrowConfig(data[i], i);
    list.push(res);
  }
  arrowMapData.value = list;
};

const calcArrowConfig = async (item, dataIndex) => {
  let matchItem = null;
  if (item?.set?.metricStyleCondition) {
    let promiseList = [];
    item?.set?.metricStyleCondition.forEach((ruleItem) => {
      promiseList.push(
          util.parseMetricCardRule(ruleItem.conditions, item, (type) => {
            if (type === "match") {
              matchItem = {
                code: item.code,
                index: dataIndex,
                color: ruleItem.color,
                iconType: ruleItem.iconType,
              };
            }
          })
      );
    });
    await Promise.all(promiseList);
  }
  return matchItem;
};
const originStyle = computed(() => {
  return {
    left: prop.value.originX + "px",
    top: prop.value.originY + "px",
  };
});
defineExpose({
  handlerRes,
});
</script>
<style lang="scss" scoped>
@import "@/styles/variables.scss";

.sk-app-edit-container {
  width: 100%;
  height: 100%;
}

.opt-box {
  position: relative;

  .opt-style {
    position: absolute;
    top: 50%;
    left: 0;
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: $primaryColor;
    transform: translateY(-50%);
  }
}

.index-card-item {
  width: 100%;
  border-left: 2px solid $primaryColor;
  display: flex;

  &.no-border {
    border-left: none;
  }

  &.bg {
    border-left: none;
    border-radius: 8px;
    padding: 16px;
  }

  .top-name {
    margin-bottom: 10px;
  }

  .v-unit {
    margin-left: 8px;
    position: relative;
    line-height: 100%;
  }
}

.index-source-item-container {
  position: relative;
  white-space: nowrap;
}

.index-source-item {
  width: 22px;
  height: 22px;
}
</style>
